const logout = (client, history) => {
  client.resetStore().then(() => {
    history.replace('/');
  });
};

export default logout;
